import { useEffect } from "react"

// Escucha el evento "triggerLogout" en localStorage para cerrar sesión una vez que
// terminen de cargar los datos necesarios para mostrar el pdf de "hacer corte y cerrar sesión"
export const useLogoutOnStorageTrigger = (onLogout: () => void): void => {
    useEffect(() => {
        const onLogoutTriggered = (event: StorageEvent) => {
            if (event.key === "triggerLogout") {
                onLogout()
            }
        }

        window.addEventListener("storage", onLogoutTriggered)

        return () => {
            window.removeEventListener("storage", onLogoutTriggered)
            localStorage.removeItem("triggerLogout")
        }
    }, [])
}
